import { React, useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Outlet, useLocation } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';// import Link from '@mui/material/Link';
import { DashboardOutlined, ExpandLess, ExpandMore, Image, SettingsOutlined } from "@mui/icons-material";
import Header from "./Header";
import LogoutIcon from '@mui/icons-material/Logout';
import favicon from './../../assets/images/favicon-32x32.png'
import {
    Backdrop,
    Breadcrumbs,
    Collapse,
    Grid,
    IconButton,
    Tooltip,
    useMediaQuery,
} from "@mui/material";
import { useSelector } from 'react-redux';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import { AVAILABLE_USER_PERMISSION } from '../../utils/constant';
import DomainIcon from '@mui/icons-material/Domain';
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import logo from '../../assets/logo.png'
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import Footer from '../Common/Footer';
const drawerWidth = 240;
const navItems = [
    {
        text: "Dashboard",
        icon: <DashboardOutlined />,
        to: "/",
        key: "1",
        requiredPermission: [],
    },
    {
        text: "Leads",
        icon: <LeaderboardOutlinedIcon />,
        to: "/leads",
        key: "2",
        requiredPermission: ["leads"],
        children: [ // <<< added nested navigation here
            {
                text: "Scrapped",
                to: "/leads/scrapped",
                icon: <CorporateFareIcon />,
                key: "2-1",
                requiredPermission: ["leads"],
            },
            {
                text: "Organic",
                to: "/leads/organic",
                key: "2-2",
                icon: <FiberManualRecordOutlinedIcon />,
                requiredPermission: ["leads"],
            },
            {
                text: "Hot Leads",
                to: "/leads/hot-leads",
                key: "2-3",
                icon: <ContactMailOutlinedIcon />,
                requiredPermission: ["leads"],
            },
        ],
    },
    {
        text: "Platforms",
        icon: <IntegrationInstructionsOutlinedIcon />,
        to: "/platform",
        key: "3",
        requiredPermission: ["platform"],
    },

    {
        text: "Domains",
        icon: <DomainIcon />,
        to: "/domain",
        key: "4",
        requiredPermission: ["domain"],
    },
    {
        text: "AI Content",
        icon: <PermMediaOutlinedIcon />,
        to: "/ai-content",
        key: "5",
        requiredPermission: ["ai_content"],
    },
    {
        text: "Industries",
        icon: <FactoryOutlinedIcon />,
        to: "/industry",
        key: "6",
        requiredPermission: ["industry"],
    },
    {
        text: "Clients",
        icon: <SupervisedUserCircleOutlinedIcon />,
        to: "/client",
        key: "7",
        requiredPermission: ["client"],
    },
    {
        text: "Roles",
        icon: <ManageAccountsOutlinedIcon />,
        to: "/roles",
        key: "8",
        requiredPermission: ["roles"],
    },
    {
        text: "Users",
        icon: <GroupAddOutlinedIcon />,
        to: "/users",
        key: "9",
        requiredPermission: ["applicationuser"],
    },
    {
        text: "Settings",
        icon: <SettingsOutlined />,
        to: "/settings",
        key: "10",
        requiredPermission: ["globalsetting"],
    },
];

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        variants: [
            {
                props: ({ open }) => open,
                style: {
                    ...openedMixin(theme),
                    '& .MuiDrawer-paper': openedMixin(theme),
                },
            },
            {
                props: ({ open }) => !open,
                style: {
                    ...closedMixin(theme),
                    '& .MuiDrawer-paper': closedMixin(theme),
                },
            },
        ],
    }),
);

export default function MiniDrawer({ color, onPress, setIsAuthenticated }) {
    const { pathname } = useLocation();
    const pathnames = pathname.split("/").filter((x) => x); // removes empty strings
    const subName = pathname.split("/").pop() || "/";
    const theme = useTheme();
    const userRole = useSelector(state => state.userReducer.userRole);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Check if screen size is small
    const [open, setOpen] = useState(!isSmallScreen);
    const [profileModal, setProfileModal] = useState(false);
    const userData = useSelector((state) => state?.userReducer?.userData);
    const userPermissions = useSelector(state => state.userReducer.userPermission)
    const [openCollapse, setOpenCollapse] = useState({})
    const isMobile = useMediaQuery('(max-width:600px)');

    const page = pathname.replace("/", "");

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        setOpen(!isSmallScreen);
    }, [isSmallScreen]);
    const handleClose = () => {
        if (isMobile) {
            setOpen(false); // Close only on mobile
        }
    };

    return (
        <Box className="main-layout" >
            <CssBaseline />
            <AppBar position="fixed" open={open} className='header-main ' >
                <Toolbar className={`header-toolbar ${open ? "drawer-open" : ""}`}>
                    <Box className='header-wrapper' >
                        <img

                            edge="start"
                            className=" bg-white drawer-favicon"
                            style={{
                                display: open ? 'none' : 'inline'
                            }}
                            src={favicon}
                        />
                        {!open && (
                            <IconButton onClick={handleDrawerOpen} className="close-wrapper ms-auto">
                                <ChevronRightIcon color='primary' />
                            </IconButton>
                        )}
                        <Breadcrumbs aria-label="breadcrumb" className="d-flex">

                            {pathnames.map((name, index) => {
                                const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
                                const isLast = index === pathnames.length - 1;

                                // const formattedName = name
                                //     .split("-")
                                //     .map(part => part.charAt(0).toUpperCase() + part.slice(1))
                                //     .join(" ");
                                const formattedName = name
                                    .split("-")
                                    .map(part => {
                                        if (part.toLowerCase() === "ai") return "AI";
                                        return part.charAt(0).toUpperCase() + part.slice(1);
                                    })
                                    .join(" ");
                                return isLast ? (
                                    <Typography key={routeTo} color="primary">
                                        {formattedName}
                                    </Typography>
                                ) : (
                                    <Typography key={routeTo} component={Link} to={routeTo} color="primary">
                                        {formattedName}
                                    </Typography>
                                );
                            })}
                        </Breadcrumbs>

                    </Box>
                    <Header {...{ profileModal, setProfileModal }} />
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent"
                className={`drawer-main ${open ? "drawer-open" : "drawer-closed"}`}
                open={open}

            >
                <DrawerHeader className="drawer-head d-flex align-items-center justify-content-between px-3">
                    <img
                        className="logo"
                        src={logo}
                        alt="logo"
                        loading="logo"
                    />
                    {open && (
                        <IconButton className="close-wrapper ms-auto" onClick={handleDrawerClose}>
                            {theme.direction === "rtl" ? <ChevronRightIcon color='primary' /> : <ChevronLeftIcon color='primary' />}
                        </IconButton>
                    )}
                </DrawerHeader>
                <Divider />
                <List className='drawer-main' >
                    <div className='sidebar-scroller' >
                        {navItems.map((item, index) => {
                            let haspermission = item.requiredPermission.every(permission =>
                                userPermissions?.some(userPerm => userPerm.model_name === permission)
                            );
                            haspermission = process.env.REACT_APP_ADMIN_ROLE === userRole || haspermission;

                            if (!haspermission) return null;

                            const isOpen = openCollapse[item.key] || false;

                            return (
                                <Box key={index}>
                                    <ListItem button onClick={() => {
                                        if (item.children) {
                                            setOpenCollapse(prev => ({
                                                ...prev,
                                                [item.key]: !prev[item.key]
                                            }));
                                        }
                                    }}>
                                        <Tooltip title={item.text} placement="right" arrow>
                                            <Box
                                                component={item.children ? "div" : NavLink}
                                                to={!item.children ? item.to : undefined}
                                                selected={page === item.to.replace("/", "")}
                                                className={page === item.to.replace("/", "") ? "active nav-list" : 'nav-list'}
                                            >
                                                <ListItemIcon>{item.icon}</ListItemIcon>
                                                <ListItemText primary={item.text} />
                                                {item.children && open && (isOpen ? <ExpandLess /> : <ExpandMore />)}
                                            </Box>
                                        </Tooltip>
                                    </ListItem>

                                    {/* Collapse for children */}
                                    {item.children && (
                                        <Collapse in={isOpen} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {item.children.map((child) => {
                                                    let childHasPermission = child.requiredPermission.every(permission =>
                                                        userPermissions?.some(userPerm => userPerm.model_name === permission)
                                                    );
                                                    childHasPermission = process.env.REACT_APP_ADMIN_ROLE === userRole || childHasPermission;

                                                    if (!childHasPermission) return null;

                                                    return (
                                                        <ListItem key={child.key} sx={{ pl: 6, pr: 4 }} className='subnavs'>
                                                            <Tooltip title={child.text} placement="right" arrow>
                                                                <Box
                                                                    component={NavLink}
                                                                    to={child.to}
                                                                    selected={page === child.to.replace("/", "")}
                                                                    className={page === child.to.replace("/", "") ? "active sub-nav-list" : 'sub-nav-list'}
                                                                >
                                                                    <ListItemIcon>{child.icon}</ListItemIcon>
                                                                    <ListItemText primary={child.text} />
                                                                </Box>
                                                            </Tooltip>
                                                        </ListItem>
                                                    )
                                                })}
                                            </List>
                                        </Collapse>
                                    )}
                                </Box>
                            );
                        })}

                    </div>
                    <ListItem
                        key='logout'
                        onClick={() => {
                            setIsAuthenticated(false)
                            localStorage.removeItem('refreshToken')
                            localStorage.removeItem('userAuthToken')
                        }}
                        className='logout-nav cursor-pointer mb-2 mt-2'
                    >
                        <Divider />
                        <Tooltip title="Logout" placement="right" arrow>
                            <div className={'nav-list'} >
                                <ListItemIcon >
                                    <LogoutIcon />
                                </ListItemIcon>
                                <ListItemText primary="Logout" />
                            </div>
                        </Tooltip>
                    </ListItem>
                </List>
                <Backdrop onClick={handleClose} />
            </Drawer>
            {/* <Box component="main" className="flex-grow-1 p-3 main-content" > */}
            <Box component="main" className={`flex-grow-1 p-3 main-content ${open ? "drawer-open" : "drawer-closed"}`}>
                <DrawerHeader />
                <Outlet />

                <Footer />
            </Box>
        </Box>
    );
}


